import AppApi from "api/App/AppApi";
import axios from "axios";
import AppConstants from "global/constants/AppConstants";
import { Result } from "global/constants/AppType";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { isRawData } from "utils/typeGuards/typeGuards";
import { useAuth } from "global/context/AuthenticationContext";

const useDKTTBModel = () => {
  const { id } = useParams();
  const { getUserInfo } = useAuth();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [orderId, setOrderId] = useState<string | undefined>(id);
  const [detailDK, setDetailDK] = useState<any>();
  const [resultObject, setResultObject] = useState<Result | null>(null);

  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);

  const [provinceCode, setProvinceCode] = useState("");
  const [districtCode, setDistrictCode] = useState("");
  const [wardCode, setWardCode] = useState("");
  const [permanentProvinceCode, setPermanentProvinceCode] = useState("");
  const [permanentDistrictCode, setPermanentDistrictCode] = useState("");
  const [permanentWardCode, setPermanentWardCode] = useState("");

  const handleOpen = async () => {
    setShowModal(true);

    setResultObject({
      type: "success",
      message: "Bạn sẽ được chuyển hướng sau 3 giây.",
    });

    setTimeout(() => {
      setShowModal(false);
      navigate("/order/dkttb");
    }, 3000);
  };

  const handleClose = async () => {
    setShowModal(false);
  };

  const getListHistory = async (id: any) => {
    try {
      setLoading(true);

      const response = await AppApi.getDkttbDetail(id);

      if (response?.code === 0) {
        setDetailDK(response?.data);
      }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const reload = async () => {
    await getListHistory(id);
  };

  const onConfirm = async (info: any) => {
    try {
      setLoading(true);

      const values = {
        ocr_info: {
          transaction_code: orderId,
          id_number: info?.id_number,
          id_type: info?.id_type,
          name: info?.name,
          dob: info?.dob,
          gender: info?.gender,
          id_issued_date: info?.id_issued_date,
          id_expired_date: info?.id_expired_date,
          id_issued_place: info?.id_issued_place,
          province: info?.province,
          ward: info?.ward,
          district: info?.district,
          permanent_province: info?.permanent_province,
          permanent_district: info?.permanent_district,
          permanent_ward: info?.permanent_ward,
          permanent_address: info?.contact_address,
          contact_address: info?.contact_address,
          province_code: info?.province_code,
          district_code: info?.district_code,
          ward_code: info?.ward_code,
          permanent_province_code: info?.permanent_province_code,
          permanent_district_code: info?.permanent_district_code,
          permanent_ward_code: info?.permanent_ward_code,
        },
        other: {
          sim_base_image_url: info?.sim_base_image,
          id_card_front_image_url: info?.id_front_image,
          id_card_back_image_url: info?.id_back_image,
          portrait_image_url: info?.portrait_image,
          signature_image_url: info?.signature_image,
          contact_image_url: info?.contact_image_url,
        },
      };
      const response = await AppApi.getSimkitConfirm(values);

      if (response?.code === 0) {
        handleOpen();
      } else {
        const message =
          response?.code === 1 ? response?.message : AppConstants.ERROR_OCCUR;
        setResultObject({
          type: "error",
          message: message ?? AppConstants.ERROR_OCCUR,
        });
        if (response?.error?.code === 416) {
          navigate(`/order/dkttb`);
        }
      }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
      getUserInfo();
    }
  };

  const handleNav = () => {
    navigate(`/order/dkttb`);
  };

  useEffect(() => {
    if (id) {
      setOrderId(id);
      getListHistory(id);
    }
  }, [id]);

  return {
    loading,
    detailDK,
    resultObject,
    showModal,
    wards,
    districts,
    provinces,
    provinceCode,
    wardCode,
    permanentProvinceCode,
    permanentDistrictCode,
    permanentWardCode,
    districtCode,
    setDistrictCode,
    setProvinceCode,
    setWardCode,
    setPermanentProvinceCode,
    setPermanentDistrictCode,
    setPermanentWardCode,
    setWards,
    setDistricts,
    handleClose,
    handleOpen,
    getListHistory,
    reload,
    setResultObject,
    onConfirm,
    handleNav,
  };
};

export default useDKTTBModel;
